import React from 'react';
import './FAQPage.css';

const FAQPage = () => {
  const faqs = [
    {
      question: "Do you offer custom orders?",
      answer: "Absolutely! We love creating custom cakes for birthdays, weddings, and other special events. Just reach out to us with your ideas."
    },
    {
      question: "Are your cakes available for delivery?",
      answer: "Yes! We offer local delivery within Nottingham and surrounding areas. Collection is also available."
    },
    {
      question: "Do you have gluten-free or vegan options?",
      answer: "No at the moment. We're working on expanding our menu to include more dietary options.\n\nAt the moment we do not have availability for Vegan, lactose intolerance or Coeliac disease people."
    },
    {
      question: "How far in advance should I place an order?",
      answer: "We recommend placing your order at least 4 days in advance to ensure availability."
    },
    {
      question: "Cake Care in Hot Weather",
      answer: "Always refrigerate your cake!\nA cool room isn't enough—warm air can cause it to melt or lose shape. Even a quick chill in the freezer helps.\n\n**Reminder:**\n• Chocolate melts at 27–30°C\n• Butter melts at 32°C\n\nKeep it cold to keep it perfect!"
    },
    {
      question: "Can I Travel with my Cake",
      answer: "Keep your cake flat and secure—the footwell or a seatbelt works best.\nChill it first in the fridge or freezer, and use ice packs or a cooler bag if possible.\nBlast the aircon on the lowest setting, and never leave the cake in a parked car."
    },
    {
      question: "How long will the cake stay fresh?",
      answer: "Keep refrigerated and consume within 3–4 days."
    },
    {
      question: "Do you have a minimum order price?",
      answer: "There is a Minimum order price only for Delivery"
    }
  ];

  const formatAnswer = (answer) => {
    return answer.split('\n').map((line, index) => {
      if (line.startsWith('**') && line.endsWith('**')) {
        return <strong key={index}>{line.slice(2, -2)}</strong>;
      }
      if (line.startsWith('• ')) {
        return <li key={index}>{line.slice(2)}</li>;
      }
      if (line.trim() === '') {
        return <br key={index} />;
      }
      return <span key={index}>{line}<br /></span>;
    });
  };

  return (
    <div className="faq-page">
      {/* Background Elements */}
      <div className="faq-background">
        <div className="background-shape shape-1"></div>
        <div className="background-shape shape-2"></div>
        <div className="background-shape shape-3"></div>
      </div>

      <div className="faq-container">
        {/* Header */}
        <div className="faq-header">
          <h1 className="faq-main-title">Frequently Asked Questions</h1>
          <p className="faq-subtitle">
            Find answers to common questions about our cakes, orders, and services
          </p>
        </div>

        {/* FAQ Items */}
        <div className="faq-content">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div className="faq-question">
                <h3>{faq.question}</h3>
              </div>
              <div className="faq-answer">
                <div className="answer-content">
                  {formatAnswer(faq.answer)}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="faq-contact-cta">
          <div className="contact-cta-card">
            <h3 className="contact-cta-title">Still have questions?</h3>
            <p className="contact-cta-description">
              Email us and we'll get back to you as soon as possible!
            </p>
            <div className="email-display">
              <a href="mailto:panelacrumbs@outlook.com" className="email-link">
                📧 panelacrumbs@outlook.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage; 